import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import LogisticCompanySwitcher from "features/app/components/LogisticCompanySwitcher";
import { formatCollaborationHeaderTitle } from "../collaborationUtils";

// Aligns the header title with the collaboration content below (JourneyStepper,
// ContentBody) which use a 32px horizontal inset.
const COLLABORATION_CONTENT_INSET = 32;

const CollaborationHeader = ({
  user,
  logisticCompanyId,
  managedLogisticCompanies,
  partner,
  contextLabel,
  onAfterSwitch
}) => {
  const { customerName, partner: partnerName } = formatCollaborationHeaderTitle({
    managedLogisticCompanies,
    logisticCompanyId,
    user,
    partner
  });

  return (
    <LogisticCompanySwitcher
      variant="onDark"
      hideLabel
      menuLayout="appBar"
      contentInset={COLLABORATION_CONTENT_INSET}
      onAfterSwitch={onAfterSwitch}
      labelSuffix={
        partnerName ? (
          <PartnerSuffix>
            <PartnerX>×</PartnerX>
            <PartnerLight>{partnerName}</PartnerLight>
            {contextLabel ? (
              <>
                <PartnerSep>|</PartnerSep>
                <PartnerLight>{contextLabel}</PartnerLight>
              </>
            ) : null}
          </PartnerSuffix>
        ) : null
      }
    >
      <CustomerName>{customerName}</CustomerName>
    </LogisticCompanySwitcher>
  );
};

CollaborationHeader.propTypes = {
  user: PropTypes.object,
  logisticCompanyId: PropTypes.number,
  managedLogisticCompanies: PropTypes.object,
  partner: PropTypes.string,
  contextLabel: PropTypes.string,
  onAfterSwitch: PropTypes.func
};

CollaborationHeader.defaultProps = {
  user: null,
  logisticCompanyId: 0,
  managedLogisticCompanies: {},
  partner: "TrackCode",
  contextLabel: null,
  onAfterSwitch: null
};

const mapStateToProps = ({
  auth: { user, logisticCompanyId = 0, managedLogisticCompanies = {} }
}) => ({
  user,
  logisticCompanyId,
  managedLogisticCompanies
});

export default connect(mapStateToProps)(CollaborationHeader);

export const navigateCollaborationAfterTenantSwitch = (_id, history) => {
  history.push("/collaboration");
};

const CustomerName = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
`;

const PartnerSuffix = styled.span`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
`;

const PartnerX = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
  margin: 0px 8px 0px -4px;
`;

const PartnerLight = styled.span`
  font-weight: 400;
`;

const PartnerSep = styled.span`
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
  margin: 0 8px;
`;
